<eg-card-select
  *transloco="let translate"
  [items]="trainOptions$ | async"
  [itemTemplate]="itemTemplate"
  [tileTemplate]="tileTemplate"
  [hideSearch]="true"
  (dropdownClosed)="markInputAsTouched()"
  (valueSelection)="onSelect($event)"
  [value]="value"
  [clearable]="false"
  [disabled]="control.disabled"
>
</eg-card-select>
<ng-template #tileTemplate>
  <div fxFlex="100" fxLayoutAlign="start center" class="label">
    @if (selectedTrain) {
      <span [class.label-top]="selectedTrain">{{ labelWithSuffix }}</span>
    }
    <span class="selected-value">{{ selectedTrain || labelWithSuffix }}</span>
  </div>
</ng-template>

<ng-template #itemTemplate let-item="item" let-selectCallback="selectCallback">
  <div
    fxFlex="100"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="4px"
    class="select__item"
    (click)="selectCallback(item)"
  >
    <div fxFlex="30" fxLayoutAlign="start center" fxLayoutGap="4px">
      {{ item.trainIdOperator }}
      @if (item.trainType === 'CUSTOMER') {
        <img src="/assets/icons/star.svg" class="svg-to-warning" alt="Special train" />
      }
    </div>
    <span fxFlex="15" class="align-center">
      <eg-pill [value]="item.remainingCapacity" [type]="'number'"></eg-pill>
    </span>
    <span fxFlex="20" class="align-center"> {{ item.planTime | egDate: 'date' }} </span>
    <span fxFlex="15" class="align-center select__item--light"> {{ item.planTime | egDate: 'time' }} </span>
    <span fxFlex="20" class="align-center">
      <eg-pill [value]="item.trainStatus" translationPrefix="support.trainStatus." [colors]="trainStatusColors"></eg-pill>
    </span>
  </div>
</ng-template>

@if (control?.touched && control?.errors && errorMessage) {
  <eg-form-error [errorMessage]="errorMessage" class="input-error"></eg-form-error>
}
